import autobind from 'autobind-decorator';
import { getIn } from 'final-form';
import React, { useMemo } from 'react';
import { Form as Form$2 } from 'react-bootstrap';
import { Form as Form$1, FormSpy } from 'react-final-form';
import { classNames } from '../../utils/class-names.js';
import { isFocusableInput } from '../../utils/focus.js';
import { FormCollection } from '../FormCollection/FormCollection.js';
import { createDecorator } from './Form.decorator.js';
import { FormContext } from './FormContext.js';
import { FormItemTemplateNormal } from '../FormItem/FormItemTemplateNormal.js';
import { BmUIKitConfig } from '../../utils/config.js';

function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function isEqualObjects(a, b) {
    return JSON.stringify(a) === JSON.stringify(b);
}
class Form extends React.Component {
    handleSubmitError(errors) {
        const { onSubmitError } = this.props;
        if (typeof onSubmitError === "function") return onSubmitError(errors);
        return true;
    }
    getAllInputs() {
        const form = this.ref?.current;
        if (typeof document === "undefined" || !form) {
            return [];
        }
        return Array.prototype.slice.call(form).filter(isFocusableInput);
    }
    findInput(inputs, errors) {
        const result = inputs.find((input)=>input?.name && getIn(errors, input.name));
        if (result) {
            const accordion = result.closest(".accordion-item");
            const accordionButton = accordion?.querySelector(".accordion-button.collapsed");
            if (accordionButton) {
                accordionButton.click();
                setTimeout(()=>{
                    result.focus();
                }, 100);
            }
            return result;
        }
    }
    render() {
        const { __virtual, as, children, className, debug, decorators, destroyOnUnregister, initialValues, initialValuesEqual, keepDirtyOnReinitialize, mutators, onChange, onDirty, onSubmit, onSubmitError: _, readOnly, ref = this.ref, showRequired, size, subscription, validate, validateOnBlur, itemTemplate, ...props } = this.props;
        const hasOnChange = typeof onChange === "function";
        const hasOnDirty = typeof onDirty === "function";
        return /*#__PURE__*/ React.createElement(Form$1, {
            debug: debug,
            decorators: [
                this.decorator,
                ...decorators
            ].filter(Boolean),
            destroyOnUnregister: destroyOnUnregister,
            initialValues: initialValues,
            initialValuesEqual: initialValuesEqual,
            keepDirtyOnReinitialize: keepDirtyOnReinitialize,
            mutators: mutators,
            onSubmit: onSubmit,
            subscription: subscription,
            validate: validate,
            validateOnBlur: validateOnBlur
        }, (renderProps)=>{
            const memo = useMemo(()=>({
                    __virtual,
                    form: renderProps.form,
                    handleSubmit: renderProps.handleSubmit,
                    readOnly,
                    size,
                    itemTemplate
                }), [
                size,
                readOnly,
                __virtual,
                itemTemplate
            ]);
            return /*#__PURE__*/ React.createElement(React.Fragment, null, hasOnDirty && /*#__PURE__*/ React.createElement(FormSpy, {
                subscription: {
                    dirty: hasOnDirty
                },
                onChange: (form)=>{
                    if (hasOnDirty) {
                        onDirty(form.dirty);
                    }
                }
            }), hasOnChange && /*#__PURE__*/ React.createElement(FormSpy, {
                subscription: {
                    values: hasOnChange
                },
                onChange: (form)=>{
                    if (hasOnChange) {
                        onChange(form.values);
                    }
                }
            }), /*#__PURE__*/ React.createElement(FormContext.Provider, {
                value: memo
            }, /*#__PURE__*/ React.createElement(FormCollection, null, ()=>/*#__PURE__*/ React.createElement(Form$2, {
                    as: as || (__virtual ? "div" : undefined),
                    className: classNames(showRequired && "form-show-required", className),
                    ...props,
                    ref: ref,
                    onReset: ()=>renderProps.form.reset(),
                    onSubmit: renderProps.handleSubmit,
                    validated: renderProps.validating,
                    noValidate: true
                }, typeof children === "function" ? children(renderProps) : children))));
        });
    }
    constructor(...args){
        super(...args), this.ref = /*#__PURE__*/ React.createRef(), this.decorator = createDecorator(this.handleSubmitError, this.getAllInputs, this.findInput);
    }
}
Form.defaultProps = {
    decorators: [],
    destroyOnUnregister: true,
    initialValuesEqual: isEqualObjects,
    itemTemplate: BmUIKitConfig.getOption("defaultFormItemTemplate") || FormItemTemplateNormal
};
_ts_decorate([
    autobind,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof ValidationErrors === "undefined" ? Object : ValidationErrors
    ]),
    _ts_metadata("design:returntype", Boolean)
], Form.prototype, "handleSubmitError", null);
_ts_decorate([
    autobind,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", Array)
], Form.prototype, "getAllInputs", null);

export { Form };
//# sourceMappingURL=Form.js.map
